import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/v2/constants/QueryKeys';
import submitSurveyResponse from '@/api/teacher/surveys/submitSurveyResponse.endpoint';
import recordSurveyImpression from '@/api/teacher/surveys/recordSurveyImpression.endpoint';
import {
  floatingSurveyQueryKey,
  subQueryKey,
} from '@/v2/domains/Surveys/constants/constants';

interface SubmitSurveyResponseData {
  code: string;
  answers: string[];
}

interface UseSubmitSurveyResponseMutationConfig {
  onSuccess?: () => void;
  clearQueries?: boolean;
}

export default function useSubmitSurveyResponseMutation(
  conf: UseSubmitSurveyResponseMutationConfig = {
    onSuccess: undefined,
    clearQueries: false,
  }
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SubmitSurveyResponseData) => {
      await Promise.all([submitSurveyResponse(data), recordSurveyImpression()]);
    },
    onSuccess: () => {
      if (conf.clearQueries) {
        queryClient.resetQueries({
          queryKey: [QUERY_KEYS.SURVEYS, subQueryKey],
        });
        queryClient.resetQueries({
          queryKey: [QUERY_KEYS.SURVEYS, floatingSurveyQueryKey],
        });
      }
      queryClient.resetQueries({
        queryKey: [QUERY_KEYS.RECOMMENDED_ACTIVITIES],
      });
      conf.onSuccess?.();
    },
    meta: {
      notification: {
        error: "We couldn't save your response. Please try again.",
      },
    },
    ...conf,
  });
}
